import screenfull from 'screenfull'
import { debug } from 'settings/custom/build'
import { Device } from 'utils/Device'

export default class FullscreenEntity extends PIXI.Container {
  constructor() {
    super()
    this.fullscreen = false
    this.visible = false

    this.initializeFullscreenBehavior()
  }

  initializeFullscreenBehavior() {
    if (Device.isIOS()) {
      this.setVisibility(false)
      return
    }

    if (Device.isMobile()) {
      if (debug) {
        return
      }

      this.toggleFullscreen()

      window.addEventListener(
        'message',
        this.handleFullscreenMessage.bind(this),
      )
    }
    else {
      this.setVisibility(false)
    }
  }

  handleFullscreenMessage(event) {
    const { type } = event.data
    if (type === 'FULLSCREEN') {
      this.toggleFullscreen()
    }
  }

  toggleFullscreen() {
    if (!this.fullscreen) {
      this.enterFullscreen()
    }
    else {
      this.exitFullscreen()
    }
    this.fullscreen = !this.fullscreen
  }

  enterFullscreen() {
    if (screenfull.isEnabled) {
      screenfull.request()
    }
  }

  exitFullscreen() {
    if (screenfull.isEnabled) {
      screenfull.exit()
    }
  }

  setVisibility(isVisible) {
    this.visible = isVisible
  }
}
